/**
 * 用户信息头部组件 - 青色横幅设计
 */

import { Avatar } from "antd";
import { UserOutlined } from "@ant-design/icons";
import type { UserInfoDetail } from "@ifa/utils";
import styles from "../Profile.module.css";

interface ProfileHeaderProps {
  userInfo: UserInfoDetail | null;
}

export function ProfileHeader({ userInfo }: ProfileHeaderProps) {
  // 显示名称：优先中文名，其次英文名，最后昵称
  const displayName =
    userInfo?.chineseName ||
    userInfo?.englishName ||
    userInfo?.nickname ||
    "用戶";

  return (
    <div className={styles.profileBanner}>
      <div className={styles.bannerContent}>
        <div className={styles.userInfo}>
          <div className={styles.greeting}>你好，{displayName}</div>
          <div className={styles.userMeta}>
            <span className={styles.metaItem}>
              IA Code:
              <span className={styles.metaValue}>
                {userInfo?.iaCode || "N/A"}
              </span>
            </span>
            <span className={styles.metaItem}>
              所屬團隊:
              <span className={styles.metaValue}>{userInfo?.teamName}</span>
            </span>
          </div>
        </div>
        <Avatar
          size={72}
          icon={<UserOutlined />}
          src={userInfo?.avatar}
          className={styles.userAvatar}
        />
      </div>
    </div>
  );
}
